import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { useIsDesktop } from 'Hooks';

interface ITitle {
  isNew: boolean;
}

export const Title = ({ isNew }: ITitle) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Feedback);
  const isDesktop = useIsDesktop();

  return isNew ? (
    <Stack>
      <Typography variant='h3' align={isDesktop ? undefined : 'center'}>
        {dictionary.newPageTitle}
      </Typography>
      <Typography variant='body3' mt={'16px'}>
        {dictionary.newPageMessage}
      </Typography>
    </Stack>
  ) : (
    <Typography variant='h3' align={isDesktop ? undefined : 'center'}>
      {dictionary.yourOpinionIsImportant}
    </Typography>
  );
};
